import React, { Component } from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import Radium from "radium";
import styleWrap from "../../globalHelpers/GlobalStyleWrapper";
import Modal from "react-modal";

class BasicModal extends Component {
    constructor(props, context) {
        super(props);

        this.state = {
            component: {},
        };
    }

    componentDidMount() {
        this.refresh(this.props);
    }

    refresh(props) {
        Express.callPublic(
            "fetch-component",
            { componentName: props.overrideComponent || "Modal" },
            (component) => {
                styleWrap(
                    { ...component.style, ...props.modalStyle },
                    (styleMap) => {
                        component.style = styleMap;
                        this.setState({ component });
                    }
                );
            }
        );
    }

    componentWillReceiveProps(newProps) {
        if (
            newProps.overrideComponent != this.props.overrideComponent ||
            newProps.refresh
        ) {
            this.refresh(newProps);
        }
    }

    render() {
        try {
            if (!this.state.component.style) {
                return <div />;
            }

            const style = this.state.component.style;

            return (
                <Modal
                    key={this.state.timeUntilExpire}
                    shouldCloseOnOverlayClick
                    isOpen={this.props.open}
                    onRequestClose={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}
                    ariaHideApp={false}
                    style={{
                        overlay: style.overlay,
                        content: {
                            ...style.content,
                            ...this.props.style,
                        },
                    }}
                    aria={{
                        label: "idea-modal",
                    }}
                >
                    {this.props.children}
                </Modal>
            );
        } catch (e) {
            console.log(e);
            return <div />;
        }
    }
}

export default Radium(BasicModal);
